module.exports = __webpack_public_path__ + "static/media/lowes.29cffb9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/lowes.jpg
// module id = 1317
// module chunks = 0